/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type EvaluationRowSchemaStatus = typeof EvaluationRowSchemaStatus[keyof typeof EvaluationRowSchemaStatus];


export const EvaluationRowSchemaStatus = {
  pending: 'pending',
  evaluating: 'evaluating',
  complete: 'complete',
  failed: 'failed',
} as const;
